import { Collection } from '../../types/database.type';
import { ResidentType } from '../person/resident.data';

export enum NewsStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived'
}

export enum NewsType {
  INFO = 'info',
  WARNING = 'warning',
  ALERT = 'alert',
  MEETING = 'meeting'
}

export enum NewsNotificationType {
  SMS = 'sms',
  MOBILE = 'mobile',
  EMAIL = 'email'
}

export enum NewsNotificationStatus {
  PENDING = 'pending',
  SENT = 'sent',
  ERROR = 'error',
  CANCELED = 'canceled'
}

export interface NewsData {
  id: string;
  title: string;
  description: string;
  status: NewsStatus;
  type: NewsType;
  publishDate: number;
  dateFrom: number;
  dateTo: number;
  meetingFrom: number | null;
  meetingTo: number | null;
  estateId: string;
  receivers?: NewsReceiversData | null;
  /** replaced by notifications in 1.6.2, reintroduced in 2.0.4 for backend calls */
  sentNotificationTypes: NewsNotificationType[];
  notifications?: {
    sms?: Collection<NewsNotification>;
    mobile?: Collection<NewsNotification>;
    email?: Collection<NewsNotification>;
  } | null; // NewsNotificationsDetails
  notificationRecipients?: ResidentType[] | null;
  notificationTimestamp: number | null;
  /** storage paths joined with '|' */
  photos: string;
  /** download urls joined with '|' */
  photosUrl: string;
  /** storage paths */
  attachments?: string[] | null;
  notificationFlags?: {
    /** on add and edit - if present will be added as sender copy */
    senderCopyEmail?: boolean | null;
    /** edit only - applies to all notification types */
    resend?: true | null;
  };
}

export interface NewsReceiversData {
  blocks?: string[] | null;
  staircases?: string[] | null;
  apartments?: string[] | null;
}

export type NewsNotificationsDetails = Partial<Record<NewsNotificationType, Collection<NewsNotification>>>;

export interface NewsNotification {
  type: NewsNotificationType;
  /** id of EmailDbData, NotificationData or (in future) sms data */
  id: string;
  /** last update date */
  date: number;
  plannedDate: number;
  status: NewsNotificationStatus;
  archived?: true | null;
}
